import { Component, OnDestroy, OnInit } from '@angular/core';

@Component({
    selector: 'app-offline-banner',
    templateUrl: './offline-banner.component.html',
    styleUrls: ['./offline-banner.component.scss']
})
export class OfflineBannerComponent implements OnInit, OnDestroy {
    isOffline = false;
    private onlineListener = () => this.updateOnlineStatus();
    private offlineListener = () => this.updateOnlineStatus();

    ngOnInit(): void {
        this.updateOnlineStatus();
        window.addEventListener('online', this.onlineListener);
        window.addEventListener('offline', this.offlineListener);
    }

    ngOnDestroy(): void {
        window.removeEventListener('online', this.onlineListener);
        window.removeEventListener('offline', this.offlineListener);
    }

    private updateOnlineStatus(): void {
        this.isOffline = !navigator.onLine;
    }
} 